
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 */
import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import Opt from "@/ts/ToolButton";
import {SizeEnum} from "@/ts/Enum";

// type size = 'small' | 'mini'
@Component
export default class ToolButton extends Vue {
  @Prop() opt: Opt;
  @Prop() size: SizeEnum;

  get srccc() {
    if (this.opt.img) {
      return require(`@/assets/images/${this.opt.img}`); //"@/assets/images/camera.png"
    }
    return null;
  }

  @Emit()
  activeClick() {
    return this.opt.key;
  }
}
